/** Admin / Accountant must pick destination agent on Receive or Deliver. */

export const RECEIVING_AGENT_PICKER_ROLES = new Set([
  'Admin',
  'System Admin',
  'Accountant',
])

export function shouldPickReceivingAgent(user, status) {
  if (!user || !RECEIVING_AGENT_PICKER_ROLES.has(user.role)) return false
  const st = String(status || '')
  return st === 'Received' || st === 'Delivered'
}

export function shipmentReceiverHubId(row) {
  const hub =
    row?.receiver_location_hub_id ??
    row?.receiver_location_hub ??
    row?.to_location_id
  if (hub === null || hub === undefined || hub === '') return null
  const n = Number(hub)
  return Number.isNaN(n) ? null : n
}

export function groupShipmentsByReceiverHub(shipments = []) {
  const map = new Map()
  for (const row of shipments) {
    const hubId = shipmentReceiverHubId(row)
    if (hubId == null) continue
    if (!map.has(hubId)) {
      map.set(hubId, {
        hubId,
        label:
          row?.receiver_location ||
          row?.consignee_location ||
          row?.receiver_location_name ||
          'Destination branch',
        shipments: [],
      })
    }
    map.get(hubId).shipments.push(row)
  }
  return [...map.values()].sort((a, b) =>
    String(a.label).localeCompare(String(b.label)),
  )
}

export function buildReceiverAgentByShipment(shipments, hubAgentPick) {
  const out = {}
  for (const row of shipments) {
    const hubId = shipmentReceiverHubId(row)
    const sid = String(row?.shipment_id || '').trim()
    if (!sid || hubId == null) continue
    const pick = hubAgentPick?.[hubId]
    const agents = pick?.agents || []
    const uid =
      pick?.selectedUserId ||
      (agents.length === 1 ? agents[0].user_id : null)
    if (uid) out[sid] = String(uid)
  }
  return out
}

export function validateHubAgentSelections(shipments, hubAgentPick) {
  const groups = groupShipmentsByReceiverHub(shipments)
  for (const group of groups) {
    const pick = hubAgentPick?.[group.hubId]
    if (pick?.loading) {
      return 'Still loading destination agents…'
    }
    const agents = pick?.agents || []
    if (agents.length === 0) {
      return `No active agent at ${group.label}.`
    }
    const selected = pick?.selectedUserId
    if (agents.length > 1 && !String(selected || '').trim()) {
      return `Select the destination agent for ${group.label}.`
    }
  }
  if (groups.length === 0 && shipments.length > 0) {
    return 'Selected shipments have no destination branch on file.'
  }
  return null
}
